import { ServiceProvider, ServiceProviderInfo } from './service-provider-info-model';
import { IpexServiceProviderCount } from './IpexServiceProviderCountModel';

export class ManagementSummaryModel {
    caseDocumentTypesSummary = new CaseDocumentTypesSummary();
    trades = [];
    stringTrades = null;
    totalAmount = null;
    serviceProvideDetails: ServiceProviderSummary[] = [];
}

export class CaseDocumentTypesSummary {
    Offers = 0;
    Invoices = 0;
    Photos = 0;
    Misc = 0;
}

export class ServiceProviderSummary {
    serviceProviderInfo = new ServiceProviderInfo();
    ipexServiceProviderCount = new IpexServiceProviderCount();

    constructor(serviceProviderInfo: ServiceProviderInfo, ipexServiceProviderCount: IpexServiceProviderCount) {
        this.serviceProviderInfo = serviceProviderInfo;
        this.ipexServiceProviderCount = ipexServiceProviderCount;
    }
}
